<template>
  <div class="registration-guide">
    <registration-header :current="0" :data="data" />
    <div v-if="data.guide" class="registration-guide-container">
      <div class="registration-guide-section">
        <div>
          <section-header :name="data.guide.title" />
          <div v-html="data.guide.content"></div>
        </div>

        <div>
          <section-header :name="data.guide.attachmentTitle" />
          <div class="registration-guide-attachments">
            <div
              v-for="(attachment, index) in data.guide.attachments"
              :key="attachment.key"
              class="attachment-item"
            >
              <div class="attachment-item-info">
                <div class="icon">
                  <img :src="getFileIcon(attachment)" />
                </div>
                <span class="name">{{ attachment.name }}</span>
              </div>
              <div class="attachment-item-action">
                <a
                  class="preview"
                  @click="handlePreview(index, attachment.name)"
                >
                  {{ $t('btn.preview') }}
                </a>
                <a @click="handleDownload(attachment)">
                  {{ $t('payroll.detail.down') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="registration-guide-footer">
      <Button v-if="$route.query.view" @click="handlePrevious">
        {{ $t('global.text18') }}
      </Button>
      <Button type="primary" @click="handleNext">
        {{ $t('global.text19') }}
      </Button>
    </div>

    <OaEmployeeAttachments ref="attachmentRef" />
  </div>
</template>
<script>
import SectionHeader from './components/SectionHeader.vue';
import OaEmployeeAttachments from '@/components/OaEmployeeAttachments.vue';
import RegistrationHeader from './components/RegistrationHeader.vue';
import { mapState } from 'vuex';

export default {
  components: {
    SectionHeader,
    OaEmployeeAttachments,
    RegistrationHeader
  },
  computed: {
    ...mapState({
      data: (state) => _.cloneDeep(state.r_form)
    })
  },
  methods: {
    getFileIcon(attachment) {
      const suffix = attachment.extension.toLowerCase();
      if (_.includes(['pdf', 'doc', 'docx', 'xls', 'xlsx'], suffix)) {
        return require(`@/assets/img/files/${suffix}.png`);
      } else if (_.includes(['jpg', 'png', 'jpeg', 'gif'], suffix)) {
        return attachment.url;
      } else {
        return require(`@/assets/img/files/file.png`);
      }
    },
    // 预览
    handlePreview(index, name) {
      this.$refs.attachmentRef.show(
        true,
        index,
        this.data.guide.attachments,
        name
      );
    },
    //下载
    async handleDownload(item) {
      try {
        const { url, name } = item;
        const res = await this.$http('get', url, {}, false, null, 'blob');
        this.$setEexlFileName(res.data, name);
      } finally {
      }
    },

    // 上一步
    handlePrevious() {
      const { params } = this.$route;
      this.$router.push({
        path: `/registration/welcome/${params.teamId}/${params.registrationTemplateId}`,
        query: {
          ...this.$route.query
        }
      });
    },
    // 下一步
    handleNext() {
      this.$router.push({
        path: this.$route.path.replace('guide', 'form'),
        query: {
          ...this.$route.query
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.registration-guide {
  overflow-y: scroll;
  height: 100vh;

  &-container {
    width: 1200px;
    box-sizing: content-box;
    box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);
    background-color: #fff;
    border-radius: 4px;
    padding: 48px;
    margin: 84px auto 84px auto;
  }

  &-attachments {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .attachment-item {
      display: flex;
      padding: 8px 0;
      border-bottom: 1px dashed #e8eaec;
      gap: 8px;

      &-info {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 12px;

        .icon img {
          width: 40px;
        }
        .name {
          text-align: left;
        }
      }

      &-action {
        display: flex;
        gap: 12px;
      }
    }
  }

  &-section {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &-footer {
    background-color: #fff;
    box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    bottom: 0;
    width: 100%;
    gap: 12px;
    z-index: 100;
  }
}

@media only screen and (max-width: 768px) {
  .registration-guide-container {
    width: 92%;
    padding: 15px 15px 100px 15px;
  }
  .preview {
    display: none;
  }

  .registration-footer {
    .mobile-footer {
      display: block;
      width: 100%;

      button {
        width: 95%;
      }
    }

    .footer {
      display: none;
    }
  }
}
</style>
